<!--课表变动-调代课审批页面 -->
<template>
  <div>
    <div class="choose">
      <van-cell-group @click.native="isYearShow=true">
        <van-field label="学年" placeholder="请选择学年" readonly v-model='selectYear' />
      </van-cell-group>
      <van-cell-group @click.native="isSessionShow=true">
        <van-field label="学期" placeholder="请选择学期" readonly v-model='selectSession' />
      </van-cell-group>
    </div>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <van-action-sheet v-model="isYearShow" :actions="yearData" @select="yearSelectFun" cancel-text="取消" close-on-click-action />
      <van-action-sheet v-model="isSessionShow" :actions="sessionData" @select="sessionSelectFun" cancel-text="取消" close-on-click-action />
      <van-list v-model="loading" :immediate-check="false" :finished="finished" finished-text="没有更多了" :offset=10 @load="loadList">
        <ul class="approval-ul">
          <li class="approval-li " v-for="(item,index) in applyList" v-bind:key="index" @click="load(item)">
            <div>
              <h3 class="class-name" v-cloak>{{item.StudentOrganizationFullName}}</h3>
              <p class="adjust-type" v-cloak>{{item.ApplyTypeName}}{{item.ApproverDate}}</p>
              <span class="effective-week" v-cloak>有效期{{item.EffectiveWeek}}周</span>
            </div>
            <!--0申请中 1待审批 2已通过 3未通过 4已拒绝 5已过期 6已撤销 7已撤回-->
            <div class="img-type">
              <img src="@/assets/csmsTimeTable/approval/approval8.png" v-if="item.SubstituteStatus === 0" />
              <img src="@/assets/csmsTimeTable/approval/approval1.png" v-if="item.SubstituteStatus === 1" />
              <img src="@/assets/csmsTimeTable/approval/approval2.png" v-if="item.SubstituteStatus === 4" />
              <img src="@/assets/csmsTimeTable/approval/approval4.png" v-if="item.SubstituteStatus === 2" />
              <img src="@/assets/csmsTimeTable/approval/approval3.png" v-if="item.SubstituteStatus === 6" />
              <img src="@/assets/csmsTimeTable/approval/approval5.png" v-if="item.SubstituteStatus === 3" />
              <img src="@/assets/csmsTimeTable/approval/approval6.png" v-if="item.SubstituteStatus === 5" />
              <img src="@/assets/csmsTimeTable/approval/approval7.png" v-if="item.SubstituteStatus === 7" />
            </div>
          </li>
        </ul>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
import { setTimeout } from "timers";
import xyapi from "@/common/api";
export default {
  name: "build",
  data () {
    return {
      page: 1,
      pageSize: 30,
      applyList: [],
      loading: false, // 是否加载中
      finished: false, // 加载是否完成
      isLoading: false, //是否处于下拉刷新状态
      //学年
      isYearShow: false,
      selectYear: "",
      selectYearId: "",
      yearData: [],
      //学期
      isSessionShow: false,
      selectSession: "",
      selectSessionId: "",
      sessionData: []
    };
  },
  created () {
    this.getYear();
  },
  methods: {
    //审批、查看审批
    load (val) {
      if (val.SubstituteStatus === 1) {
        //审批
        if (val.ApplyType === 1 || val.ApplyType === 2) {
          //调课
          this.$router.push({ path: "/home/AdjustDetails", query: val });
        } else if (val.ApplyType === 3) {
          //代课
          this.$router.push({ path: "/home/SubsituteDetails", query: val });
        }
      } else {
        this.$router.push({ path: "/home/ApprovalDetails", query: val });
      }
    },
    //选中学年
    yearSelectFun (e) {
      this.selectYear = e.name;
      this.selectYearId = e.id;
      //选择学年时把联动的学期置空
      this.selectSession = "";
      this.selectSessionId = "";
      this.sessionData = [];
      this.getSession(e.id);
    },
    // 选中学期
    sessionSelectFun (e) {
      this.selectSession = e.name;
      this.selectSessionId = e.id;
      this.page = 1;
      this.applyList = [];
      this.onRefresh();
    },
    //获取学年
    async getYear () {
      let that = this;
      let res = await xyapi.get(this.xyMApi + "/xy/comm/YearList");
      if (res.success) {
        if (res.data.length > 0) {
          res.data.map(item => {
            if (item.IsCurrent) {
              that.selectYearId = item.ID;
              that.selectYear = item.Name;
              that.getSession(item.ID);
            }
            that.yearData.push({
              id: item.ID,
              name: item.Name
            });
          });
        }
      } else {
        that.$toast.fail(res.msg);
      }
    },
    //获取学期
    async getSession (id) {
      let that = this;
      let res = await xyapi.get(this.xyMApi + "/xy/comm/SessionList", {
        yearID: id
      });
      if (res.success) {
        res.data.map(item => {
          if (item.IsCurrent) {
            that.selectSessionId = item.AcademicSessionID;
            that.selectSession = item.AcademicSessionName;
            that.onRefresh();
          }
          that.sessionData.push({
            id: item.AcademicSessionID,
            name: item.AcademicSessionName
          });
        });
      } else {
        that.$toast.fail(res.msg);
      }
    },

    loadList () {
      this.xy.loading()
      let that = this;
      let obj = {
        type: 0,
        academicYearID: this.selectYearId,
        academicSessionID: this.selectSessionId,
        state: -1,
        schoolDistrictID: 0,
        searchText: "",
        pageIndex: this.page,
        pageSize: this.pageSize
      };
      let ulr = `${this.$store.state.apiPath}/api/ClassTableGenerateForTeacherApplyExamine/GetTeaherApplyList`;
      xyapi.get(ulr, obj).then(res => {
        let list = res.data.data;
        that.applyList = [...that.applyList, ...list];
        that.loading = false;
        that.page++;
        this.xy.unloading()
        that.finished = (that.applyList.length >= res.data.totalRecords) ? true : false;

      });
    },
    onRefresh () {
      setTimeout(() => {
        this.applyList = [];
        this.page = 1;
        this.isLoading = false;
        this.loadList();
      }, 500);
    }
  }
};
</script>
<style lang="less" scoped>
.choose {
  display: flex !important;
  margin: 8px 0;
  /deep/ .van-field__label {
    width: auto !important;
    margin-right: 16px !important;
    span {
      font-size: 16px !important;
    }
  }
  /deep/ .van-field__body {
    input {
      font-size: 14px !important;
    }
  }
}
.approval-ul {
  margin: 10px 19px;
  .approval-li {
    margin-bottom: 16px;
    height: 220px;
    background: #fff;
    box-shadow: 0px 2px 21px 0px rgba(197, 197, 197, 0.5);
    border-radius: 6px;
    padding: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    div:first-child {
      width: 80%;
      .class-name {
        font-size: 28px;
        font-weight: bold;
        color: #333333;
        margin-bottom: 51px;
        max-width: 90%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .effective-week {
        font-size: 24px;
        display: inline-block;
        padding: 8px 30px 7px 11px;
        color: #8a8a8a;
        background: #f6f6f7;
        border-radius: 16px 0px 16px 0px;
      }
      .adjust-type {
        font-size: 22px;
        color: #8a8a8a;
        margin-bottom: 26px;
      }
    }

    .img-type {
      img {
        width: 102px;
      }
    }
  }
}
</style>